import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=ab48800c"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab48800c')) {
      api.createRecord('ab48800c', component.options)
    } else {
      api.reload('ab48800c', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=ab48800c", function () {
      api.rerender('ab48800c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/Edit.vue"
export default component.exports